import { useQuery } from '@apollo/client/react';
import { Authorization, POLICIES } from '@/lib/Authorization';
import { MainView } from '@repo/ui/Views';

import { FallbackCard } from '@repo/ui/Card';

import UpdateUserForm from '../components/UpdateUserForm';
import ChangeUserRole from '../components/ChangeUserRole';
import UpdateUserPassword from '../components/UpdateUserPassword';

import DeleteUser from '../components/DeleteUser';
import USERS_SHOW_Q from '../gql/show.gql';
import { useUser } from '@repo/hooks/useUser';
import { useParams } from 'react-router';
import { useAccount } from '@/hooks/useAccount';

const UpdateUser = () => {
  const user = useUser();
  const account = useAccount();
  const accountId = account.id;
  const params = useParams();
  const userId = params.userId;

  const { loading, data, refetch } = useQuery(USERS_SHOW_Q, {
    variables: {
      id: String(userId),
    },
  });

  return (
    <MainView
      title={
        loading
          ? `Update user`
          : `Update user: ${data?.user.first_name || data?.user.last_name ? `${data?.user.first_name} ${data?.user.last_name}` : data?.user.name} `
      }
    >
      <div className="flex flex-col gap-12">
        {data?.user ? (
          <>
            <Authorization
              policyCheck={POLICIES['user:update'](user)}
              fallbackView={
                <FallbackCard
                  title="No access"
                  description="You do not have the permissions to update users."
                />
              }
            >
              <UpdateUserForm
                userId={data.user.id}
                email={data.user.email}
                first_name={data.user.first_name}
                last_name={data.user.last_name}
                refetch={refetch}
              />

              <ChangeUserRole
                userId={data?.user?.id}
                accountId={accountId}
                loading={loading}
                currentRole={data?.user?.role}
              />
              <UpdateUserPassword userId={data?.user.id} />
            </Authorization>
            <Authorization
              policyCheck={POLICIES['user:delete'](user)}
              fallbackView={
                <FallbackCard
                  title="No access"
                  description="You do not have the permissions to delete users."
                />
              }
            >
              <DeleteUser
                first_name={data.user.first_name}
                last_name={data.user.last_name}
                email={data.user.email}
                loading={loading}
                userId={data.user.id}
                accountId={accountId}
              />
            </Authorization>
          </>
        ) : null}
      </div>
    </MainView>
  );
};

export default UpdateUser;
